import React, { ReactNode } from "react";
import classNames from "classnames";

import ReadyForDelivery from "../ReadyForDelivery";

const ValueProp = ({
  heading,
  description,
}: {
  heading: string;
  description: ReactNode;
}) => (
  <div className="mb-lg overflow-hidden">
    <p className="font-extrabold mb-xs text-md">{heading}</p>
    <p>{description}</p>
  </div>
);

const DeliveryFromLeafly = ({
  className,
  showCTA,
}: {
  className?: string;
  showCTA?: boolean;
}) => (
  <section className={classNames("container", className)}>
    <h2 className="mb-xl mt-xl text-center">How delivery works</h2>
    <div
      className={classNames(
        "flex flex-col items-center md:flex-row md:text-left text-center justify-center mb-xxl md:m-0",
        { "justify-center md:text-center": !showCTA },
      )}
    >
      <div
        className={classNames("flex flex-col justify-between", {
          "lg:col-1/3": !showCTA,
          "md:pr-xxl": showCTA,
        })}
      >
        <ValueProp
          heading="Shop local"
          description={
            <>
              <span className="block lg:inline">
                Enter your address to shop legal{" "}
              </span>
              <span className="block lg:inline">
                delivery dispensaries nearby.
              </span>
            </>
          }
        />
        <ValueProp
          heading="Order it up"
          description={
            <>
              <span className="block lg:inline">
                THC, CBD, vapes, wax, pre-rolls,{" "}
              </span>
              <span className="block lg:inline">
                whatever! It’s legal, friends.
              </span>
            </>
          }
        />
        <ValueProp
          heading="Keep an eye out"
          description={
            <>
              <span className="block lg:inline">
                Your store will text or email you with{" "}
              </span>
              <span className="block lg:inline">
                updates. Have your ID and payment ready.
              </span>
            </>
          }
        />
      </div>
      <ReadyForDelivery className="rounded shadow-low w-full" />
    </div>
  </section>
);

export default DeliveryFromLeafly;
